var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 468,
    height: 468,
    viewBox: "0 0 468 468",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 234,
    r: 230.5,
    fill: "white",
    stroke: "black",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.132 134.841C185.124 128.551 176.805 126.706 170.515 130.714C164.225 134.721 162.38 143.04 166.387 149.331L213.479 223.249C215.471 226.376 214.542 230.565 211.415 232.557C208.288 234.55 204.099 233.621 202.107 230.494L162.26 167.947C158.253 161.657 149.933 159.813 143.643 163.82C137.353 167.827 135.509 176.147 139.516 182.437L201.097 279.099C201.358 279.51 208.474 290.68 211.805 295.873C212.33 296.691 211.388 298.087 210.432 297.908L179.179 292.063C170.052 290.284 161.197 296.225 159.382 305.375C157.567 314.525 163.544 323.357 172.694 325.172L236.863 337.75C261.485 342.598 287.032 337.764 308.213 324.27L315.036 319.924C349.578 297.917 359.515 251.718 326.189 199.407L279.098 125.488C275.091 119.198 266.772 117.354 260.481 121.361C254.191 125.368 252.347 133.688 256.354 139.978L281.711 179.78C283.703 182.907 282.775 187.096 279.647 189.089C276.52 191.081 272.331 190.152 270.339 187.025L230.492 124.479C226.485 118.189 218.166 116.344 211.876 120.351C205.585 124.359 203.741 132.678 207.748 138.968L247.595 201.515C249.587 204.642 248.658 208.831 245.531 210.823C242.404 212.815 238.215 211.887 236.223 208.759L189.132 134.841Z",
    fill: "#0039A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M327.14 135.148C343.784 144.727 360.428 172.861 359.221 192.605",
    stroke: "#0039A7",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M333.671 97.0146C381.707 104.389 405.936 189.715 392.031 202.778",
    stroke: "#0039A7",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.706 309.704C125.062 300.125 108.418 271.991 109.625 252.247",
    stroke: "#0039A7",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.175 347.837C87.1389 340.463 62.9104 255.137 76.8155 242.075",
    stroke: "#0039A7",
    strokeWidth: 12,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.d5212a4960a403a966d5f677f2a37f73.svg";
export { ForwardRef as ReactComponent };